const selectedGroup = (value: Array<any>, groupId: string | number) =>
  value.find(({ id }) => id === groupId);

export default selectedGroup;



// WEBPACK FOOTER //
// ./src/services/agestrict/utils/selectedgroup.ts